import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import { MyCustomSelect } from 'components/common';
import { impactTypeOptions } from 'components/widgets/RiskRegister/RiskRegister.utils';
import classes from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/Details/Details.module.scss';

export const ImpactType = () => {
    const { setValue, control } = useFormContext<Risk>();
    return (
        <div className={classes.selectWrapper}>
            <div className={classes.title}>Impact type:</div>
            <div data-testid={'impact-type'} className={classes.content}>
                <Controller
                    render={({ field }) => (
                        <MyCustomSelect<ISelectOption<Risk['impactType']>>
                            {...field}
                            value={impactTypeOptions.find((option) => option.value === field.value)}
                            onChange={(value) => value && setValue('impactType', value.value, { shouldDirty: true })}
                            options={impactTypeOptions}
                            placeholder="Select impact type"
                            isClearable={false}
                        />
                    )}
                    name="impactType"
                    control={control}
                />
            </div>
        </div>
    );
};
